import { Button, Flex, Text } from '@chakra-ui/react';
import { formatPhoneNumber } from '~/common/utils/formatter';
import { UserAvatar } from '../User/UserAvatar';

export const UserAccessRow = ({
  email,
  phoneNumber,
  onRemove,
}: {
  email?: string;
  phoneNumber?: string;
  onRemove: () => void;
}) => {
  if (!email && !phoneNumber) {
    return null;
  }

  const formattedPhoneNumber = formatPhoneNumber(phoneNumber);

  return (
    <Flex alignItems="center" justifyContent="space-between">
      <Flex alignItems="center" gap={2}>
        <UserAvatar size="xs" />
        <Text>{email || formattedPhoneNumber}</Text>
      </Flex>
      <Button size="sm" variant="link" onClick={onRemove}>
        Remove
      </Button>
    </Flex>
  );
};
